module.exports = __webpack_public_path__ + "img/icon-status.26af34e1.svg";